import { Stack } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IAppReduxStore } from '../../../redux/store';

/**
 * Component that allows the user to change the area of the Project that they are working in.
 */
export default () => {
    /** Configure component translation. */
    const { i18n } = useTranslation();

    /** Get relevant values from Redux store. */
    const areas = useSelector((store: IAppReduxStore) => store.projectAreas.data);

    /** Get the replicaId and areaName from the react router. */
    const { areaName } = useParams();

    if (!areas) {
        return <></>;
    }

    return (
        <Stack sx={{ ml: 1 }}>{areas?.[areaName]?.translations[i18n.language] ?? areaName}</Stack>
    );
};
